module.exports = __webpack_public_path__ + "img/sosial.42189d42.png";